import { PageListCachedDataSource } from './BaseDataSources';
import { IDeal } from '../Interfaces';

export class DealSource extends PageListCachedDataSource<IDeal> {
  /**
 * @param {number[]} loanIds - A required parameter.
 */
  public constructor(loanIds: number[]) {
    super('/datasource/deals', { loanIds });
  }
}